import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  Renderer2,
} from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { ReportingServiceService } from "src/app/shared/services/reporting-service.service";
import { ReportlinksserviceService } from "src/app/user/reportlinks/reportlinksservice.service";
import { FormsModule } from "@angular/forms";
import { AnalysisService } from "src/app/shared/services/analysis.service";
import { TemplateReportService } from "src/app/shared/services/template-report.service";
import { constants } from "src/app/shared/common/contants";

@Component({
    selector: "app-report-analysis",
    templateUrl: "./report-analysis.component.html",
    styleUrls: ["./report-analysis.component.scss"],
    standalone: false
})
export class ReportAnalysisComponent implements OnInit {
  @Input() reportTemplateId: any;
  @Input() selectedActivity: any;
  @Input() instancedetailid :any;
  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<String>();

  activeComponent: "history" | "upcoming" | "reportTemplate" = "history"; // default
  activeSection: "report" | "analysis" = "analysis"; // default show analysis
  datasets: any[] = [];
  getdata: any = [];
  UserRolesWithRoleId: any[];
  selectedDataset: any = null;
  backgroundColorScreen = "";
  backgroundColorButton = "";
  selectedTemplate: any;
  componentLoaded = false;
  AllReportTemplates: any;
  analysisGenerated: boolean = false;
allSheets: any = {};
sheetNames: string[] = [];
selectedSheet = '';
rowData: any[] = [];
columnDefs: any[] = [];
columnHeaders: string[] = [];
fullRowData: any[] = [];
filteredRowData: any[] = [];
pageSizeValue: number | 'ALL' = 200;
pageSize = 200;
currentPage = 1;
totalPages = 1;
pageInput = 1;
searchText = '';
fileName

reportTitleRow: any[] = [];
reportInfoRow: any[] = [];
reportHeaderRow: any[] = [];
displayRowData: any[][] = [];

showNextButton:boolean=true;
  constructor(
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private router: Router,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private jsignalsService: JsignalService,
    private linkservice: ReportlinksserviceService,
    private service: ReportingServiceService,
    private analysisService: AnalysisService,
    private Reportservice: TemplateReportService,
    private constants:constants
  ) {}

  ngOnInit(): void {
    // this.Useroles(); // first load user roles
    // this.loadAllDatasets(); // then load datasets
    // this.fetchReportTemplates();

    if(this.selectedActivity){
      const activityEndDate = this.selectedActivity.endDate;
console.log(this.selectedActivity.endDate);

      const endDate = new Date(activityEndDate);
      const currentDate = new Date();
console.log(endDate);
console.log(currentDate);
console.log(endDate < currentDate);
console.log(endDate > currentDate);
console.log("****************************");


      if (endDate < currentDate) {
       this.showNextButton= true
      } else {
       this.showNextButton= false
      }
    }
    // this.reportTemplateId
    if(this.reportTemplateId && this.instancedetailid){
      this.spinner.start();
      this.activeSection = "report"
    
       this.jsignalsService.getReportBasedOnTemplateId(this.reportTemplateId,this.instancedetailid).subscribe({
      next: (res: any) => {
        if(res.error == true){
          this.snackBar.open(res.statusMessage, "Ok", {
              duration: 3000,
            });
             this.spinner.stop();
             this.goBack()
        }else{
           // this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            console.log(res);
            this.allSheets = res;
             const sheetData = this.allSheets['Report'] || [];

            this.reportTitleRow = sheetData[0] || [];
            this.reportInfoRow = sheetData[1] || [];

            console.log("*************************************");
            console.log(sheetData);
            console.log(this.reportTitleRow);
            console.log(this.reportInfoRow);
            
            
            
          this.sheetNames = Object.keys(res);

          if (this.sheetNames.length > 0) {
            this.selectSheet(this.sheetNames[0]);
          }
            this.spinner.stop();
        }
       
      },
      error: (err) => {
        console.error("Assign error:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", {
          duration: 3000,
        });
        this.spinner.stop();
      },
      });
    }else{
       this.snackBar.open("Report Template is not configured", "Ok", {
          duration: 3000,
        });
      this.goBack()
    }
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
   
  }

selectSheet(sheetName: string) {
  this.selectedSheet = sheetName;

  const sheetData = this.allSheets[sheetName] || [];

  if (sheetName === 'Report') {
    this.reportTitleRow = sheetData[0] || [];
    this.reportInfoRow = sheetData[1] || [];
    this.reportHeaderRow = sheetData[2] || [];

    this.fullRowData = sheetData.slice(3);
  } else {
    // this.reportTitleRow = [];
    // this.reportInfoRow = [];
    this.reportHeaderRow = [];

    this.fullRowData = sheetData;
  }

  this.searchText = '';
  this.filteredRowData = [...this.fullRowData];

  this.currentPage = 1;
  this.pageInput = 1;

  this.updatePagination();
}

applySearch() {
  const search = (this.searchText || '').toLowerCase().trim();

  if (!search) {
    this.filteredRowData = [...this.fullRowData];
  } else {
    this.filteredRowData = this.fullRowData.filter((row: any[]) =>
      row.some(cell =>
        String(cell || '').toLowerCase().includes(search)
      )
    );
  }

  this.currentPage = 1;
  this.pageInput = 1;
  this.updatePagination();
}

updatePagination() {
  // this.totalPages = Math.ceil(this.filteredRowData.length / this.pageSize) || 1;
  // this.loadPage();
   if (this.pageSizeValue === 'ALL') {
    this.pageSize = this.filteredRowData.length || 1;
  }

  this.totalPages = Math.ceil(this.filteredRowData.length / this.pageSize) || 1;
  this.loadPage();
}

loadPage() {
  const start = (this.currentPage - 1) * this.pageSize;
  const end = start + this.pageSize;

  this.rowData = this.filteredRowData.slice(start, end);
}

nextPage() {
  if (this.currentPage < this.totalPages) {
    this.currentPage++;
    this.pageInput = this.currentPage;
    this.loadPage();
  }
}

prevPage() {
  if (this.currentPage > 1) {
    this.currentPage--;
    this.pageInput = this.currentPage;
    this.loadPage();
  }
}

goToPage() {
  const page = Number(this.pageInput);

  if (!page || page < 1) {
    this.pageInput = 1;
    return;
  }

  if (page > this.totalPages) {
    this.pageInput = this.totalPages;
    return;
  }

  this.currentPage = page;
  this.loadPage();
}

onPageSizeChange() {
  if (this.pageSizeValue === 'ALL') {
    this.pageSize = this.filteredRowData.length || 1;
  } else {
    this.pageSize = Number(this.pageSizeValue);
  }

  this.currentPage = 1;
  this.pageInput = 1;
  this.updatePagination();
}

downloadSheet(){
   this.spinner.start();
    this.snackBar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
      this.jsignalsService.downloadReportBaedOnTemplateId(646,11806).subscribe(x => {
        console.log(x);
        
        // this.spinner.start()
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData) {
          this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

      this.spinner.stop();
        } else {
          console.log(x)
          var newBlob = new Blob([x.body]);
           const contentDisposition = x.headers.get('content-disposition');

         this.fileName = 'download.xlsx';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+)"/);
            if (match && match.length > 1) {
              this.fileName = match[1];
            }
          }
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = this.fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
          setTimeout(function() {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
          /**
           * modified by Ashwin M
           * 08/01/2025
           * code modified to display file download confirmation
           */
          this.snackBar.open("Download Completed", "OK", {duration: 5000});
          
      this.spinner.stop();
        }

      })

}
  showHistory() {
    this.activeComponent = "history";
  }

  showUpcoming() {
    this.activeComponent = "upcoming";
  }

  showReportTemplate() {
    this.activeComponent = "reportTemplate";
  }
  goToAssessment() { 
    if (this.activeSection === 'analysis') {

    // No dataset selected
    if (!this.selectedDataset) {
      this.snackBar.open("Please select a dataset before proceeding.", "OK", {
        duration: 3000,
      });
      return;
    }

    //  Dataset selected but user did NOT click ANALYSIS
    if (!this.analysisGenerated) {
      this.snackBar.open(
        "Please click on the 'Analysis' button before proceeding.",
        "OK",
        { duration: 3000 }
      );
      return;
    }
  }

    this.next.emit("Reports");
  }

  goBack() {
    this.back.emit();
  }

  switchSection(section: "report" | "analysis") {
    this.activeSection = section;
  }
  runAdhoc() {
    this.activeComponent = "history";
    this.componentLoaded = true;
  }

  scheduleReport() {
    this.activeComponent = "upcoming";
    this.componentLoaded = true;
  }

  openAnalysis(selectedDataset: any) {
  if (!selectedDataset) {
    this.snackBar.open("Please select a dataset", "OK", { duration: 3000 });
    return;
  }
    console.log("Opening analysis view...");
    // Select dataset added Into data To Match The Common Analysis Method to generate QuickSight
    const data = {
      rowData: selectedDataset,
    };
    // Selected Dataset added Inside rowData
    console.log("Simulated row data:", data);
    console.log("Report Creation ID:", data.rowData.reportcreationid);

    this.analysisService.analysis(data).subscribe((status) => {

    if (status === "cancel") {
      this.analysisGenerated = false;
      this.snackBar.open("Analysis Creation Cancelled. Please Click On Proceed to generate quicksight ", "OK", { duration: 3000 });
      return; // user cancelled → don't allow next
    }

    if (status === "success") {
      this.analysisGenerated = true;
      return; // all good
    }

    if (status === "failed") {
      // SHOW CONFIRM BOX
      const userConfirmed = confirm(
        "For this dataset analysis is not generated. Do you still want to proceed?"
      );

      if (userConfirmed) {
        this.analysisGenerated = true;   // allow next
      } else {
        this.analysisGenerated = false;  // block next
      }
    }
  });

  }
  loadAllDatasets() {
    this.linkservice
      .retrievereport(
        this.localStorage.getSettings("UserId"),
        this.localStorage.getSettings("dnsName"),
        this.localStorage.getSettings("AuthUsername")
      )
      .subscribe((response) => {
        this.spinner.start();
        console.log(response);
        // checking if response is true or not
        if (response.error == true) {
          this.snackBar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          // this.rowbindingdata.setGridOption('rowData', []);
          this.datasets = [];
          this.selectedDataset = null;
        } else {
          // below code added for dispaly associated roles of Dataset in the Grid
          console.log(response);
          this.getdata = response;
          console.log(this.getdata);
          for (let i = 0; i < this.getdata.length; i++) {
            let stringValues = "";
            if (this.getdata[i].dataset_rolesIds) {
              let subString = this.getdata[i].dataset_rolesIds.split(",");
              console.log(subString);
              for (let j = 0; j < subString.length; j++) {
                console.log(this.UserRolesWithRoleId);
                for (let k = 0; k < this.UserRolesWithRoleId.length; k++) {
                  console.log(this.UserRolesWithRoleId[k][0]);
                  if (this.UserRolesWithRoleId[k][0] == subString[j]) {
                    if (stringValues.length == 0) {
                      stringValues = this.UserRolesWithRoleId[k][1];
                      break;
                    } else {
                      stringValues =
                        stringValues + "," + this.UserRolesWithRoleId[k][1];
                      break;
                    }
                  }
                }
              }
              this.getdata[i]["dataset_rolesIdStrings"] = stringValues;
            }
          }
          console.log(this.getdata);
          // Filter active datasets only (status === 'Yes') && Completed Data Set
          this.datasets = this.getdata.filter(
            (ds: any) =>
              ds.status === "Yes" && ds.generationStatus === "Completed"
          );
        }
        this.spinner.stop();
      });
  }
  onDatasetSelect() {
      this.analysisGenerated = false; // reset validation
    if (this.selectedDataset) {
      console.log("Selected Dataset:", this.selectedDataset);

      // You can also access specific properties if needed:
      console.log(
        "Dataset Name:",
        this.selectedDataset.datasetname,
        "| Description:",
        this.selectedDataset.description,
        "| Type:",
        this.selectedDataset.datasetType,
        "| Status:",
        this.selectedDataset.status
      );
    } else {
      console.log("No dataset selected");
    }
  }
  Useroles(): void {
    const dnsid = this.localStorage.getSettings("dnsName");
    if (dnsid) {
      this.service.getUserRoles(dnsid).subscribe(
        (response) => {
          this.UserRolesWithRoleId = response; // Assign fetched user roles to the types array
          console.log(this.UserRolesWithRoleId);
        },
        (error) => {
          console.error("Error fetching user roles:", error);
        }
      );
    }
  }

  // Fetch All Report Templates based on dnsid

  fetchReportTemplates() {
    this.Reportservice.retrieveReportTemplatesByDnsId().subscribe(
      (response) => {
        console.log(response);

        if (response.error == true) {
          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
        } else {
          this.spinner.stop();
          this.AllReportTemplates = (response as any).filter(
            (t: any) => t.status === "Yes"
          );
          console.log(this.AllReportTemplates);
        }
      }
    );
  }

  //
  onReportSelected() {
    if (this.selectedTemplate) {
      console.log(this.selectedTemplate);
      console.log("Report Name :", this.selectedTemplate.reportTemplateName);
      console.log("Report Type :", this.selectedTemplate.reportTypeName);
    } else {
      console.error("No Report Selected");
    }
  }
}
